export const commonTranslations = {
    en: {
        // Pagination translations - directly in the root object
        previous: 'Previous',
        next: 'Next',
        showing: 'Showing',
        to: 'to',
        of: 'of',
        results: 'results',
        rows_per_page: 'Rows per page:',
        save: 'Save Changes',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        enabled: 'Enabled',
        disabled: 'Disabled',
        status: 'Status',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        saving: 'Saving...',
        active: 'Active',
        inactive: 'Inactive',
        name: 'Name',
        email: 'Email',
        role: 'Role',
        actions: 'Actions',
        price: 'Price',
        color: 'Color',
        selectColor: 'Select a color',
        title: 'Orders',
        filters_title: 'Filters',
        export: 'Export',
        no_orders: 'No Orders',
        no_orders_found: 'No orders found matching your search criteria',
        order_number: 'Order #',
        date: 'Date',
        customer: 'Customer',
        payment_method: 'Payment Method',
        total: 'Total',
        walk_in_customer: 'Walk-in Customer',
        cash: 'Cash',
        card: 'Card',
        view_order: 'View Order',
        print_invoice: 'Print Invoice',
        edit_order: 'Edit Order',
        return_order: 'Return Order',
        delete_order: 'Delete Order',
        returned: 'Returned',
        total_orders: 'Total Orders',
        cash_orders: 'Cash Orders',
        card_orders: 'Card Orders',
        returned_orders: 'Returned Orders',
        uploaded: 'Uploaded'
    },
    ar: {
        // Pagination translations - directly in the root object
        previous: 'السابق',
        next: 'التالي',
        showing: 'عرض',
        to: 'إلى',
        of: 'من',
        results: 'نتيجة',
        rows_per_page: 'صفوف في الصفحة:',
        save: 'حفظ التغييرات',
        cancel: 'إلغاء',
        delete: 'حذف',
        edit: 'تعديل',
        enabled: 'مفعل',
        disabled: 'غير مفعل',
        status: 'الحالة',
        loading: 'جاري التحميل...',
        error: 'خطأ',
        success: 'نجاح',
        saving: 'جاري الحفظ...',
        active: 'نشط',
        inactive: 'غير نشط',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        role: 'الدور',
        actions: 'الإجراءات',
        price: 'السعر',
        color: 'اللون',
        selectColor: 'اختر لون',
        title: 'الطلبات',
        filters_title: 'فلاتر',
        export: 'تصدير',
        no_orders: 'لا توجد طلبات',
        no_orders_found: 'لم يتم العثور على طلبات تطابق معايير البحث',
        order_number: 'رقم الطلب #',
        date: 'التاريخ',
        customer: 'العميل',
        payment_method: 'طريقة الدفع',
        total: 'المجموع',
        walk_in_customer: 'عميل عابر',
        cash: 'نقداً',
        card: 'بطاقة',
        view_order: 'عرض الطلب',
        print_invoice: 'طباعة الفاتورة',
        edit_order: 'تعديل الطلب',
        return_order: 'إرجاع الطلب',
        delete_order: 'حذف الطلب',
        returned: 'مرتجع',
        total_orders: 'إجمالي الطلبات',
        cash_orders: 'طلبات نقدية',
        card_orders: 'طلبات بطاقة',
        returned_orders: 'الطلبات المرتجعة',
        uploaded: 'مرفوع'
    }
};
